import { IGoodReceive } from '@/interfaces/goodReceive';
import { formatThaiDate, formatNumber } from '@/utils/dataUtils';
import { sumBy, uniqBy } from 'lodash';
import React from 'react';

interface IProps {
  data?: IGoodReceive;
}

const TemplateGrnInfoItem = ({ data }: IProps) => {
  const uniqueProductsCount = uniqBy(
    data?.goodReceiveItems || [],
    'productId',
  ).length;
  return (
    <>
      <div className="flex w-full text-xs mt-5">
        <table
          border={1}
          cellSpacing={0}
          cellPadding={2}
          style={{
            width: '100%',
            border: '0.5px; black solid',
            borderCollapse: 'collapse',
          }}
        >
          <tr>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
              width={100}
            >
              <strong>ITEM NO.</strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
              width={100}
            >
              <strong>BARCODE/GTIN</strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
            >
              <strong>DESCRIPTION</strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
            >
              <strong>LOT NO.</strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
              width={80}
            >
              <strong>EXPIRATION DATE</strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
              width={40}
            >
              <strong>UOM</strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
              width={60}
            >
              <strong>QUANTITY</strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
              width={100}
            >
              <strong>QUANTITY TO RECEIVED</strong>
            </td>
          </tr>
          {data?.goodReceiveItems?.map(i => {
            return (
              <tr key={i.id}>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'center',
                  }}
                >
                  {i.productCode}
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'center',
                  }}
                >
                  {i.barCode}
                </td>
                <td
                  style={{
                    border: '1px solid black',
                  }}
                >
                  {i.productName}
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'center',
                  }}
                >
                  {i.lotNumber}
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'center',
                  }}
                >
                  {formatThaiDate(i.expiredDate)}
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'center',
                  }}
                >
                  {i.packageUnitId}
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'right',
                  }}
                >
                  {formatNumber(i.poQuantity, 2)}
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'right',
                  }}
                >
                  {formatNumber(i.quantity, 2)}
                </td>
              </tr>
            );
          })}
          <tr>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'left',
                verticalAlign: 'middle',
              }}
              width={100}
              colSpan={5}
            >
              <strong>ITEM COUNT : {uniqueProductsCount}</strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
              width={60}
            >
              <strong>TOTAL:</strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'right',
                verticalAlign: 'middle',
              }}
              width={100}
            >
              <strong>
                {formatNumber(sumBy(data?.goodReceiveItems, 'quantity'), 2)}
              </strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'right',
                verticalAlign: 'middle',
                paddingTop: 5,
                paddingBottom: 5,
              }}
              width={100}
            >
              <strong>
                {formatNumber(sumBy(data?.goodReceiveItems, 'quantity'), 2)}
              </strong>
            </td>
          </tr>
        </table>
      </div>
    </>
  );
};

export default TemplateGrnInfoItem;
